import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { useAuth } from "provider/AuthContext";
import { useMessageContext } from "provider/MessageProvider";
import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { PiPaperPlaneRightFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import TextareaAutosize from 'react-textarea-autosize';


const MessageForm = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const { msg, activeUser, quotationContact, directContact, activeTab,newMessageAdded, messageDispatch } = useMessageContext();
    const activeUserStatus = activeUser?.chat_hash ? false : true;
    const textareaRef = useRef(null);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [posting, setPosting] = useState(false);
    // const [ , setLoading] = useState(false);

    const maxLength = 1000;

    const handleChange = (e) => {
        const value = e.target.value.slice(0, maxLength);
        setMessage(value);
        if (value.trim()) setError("");
    };

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    }, [activeUser, activeTab, newMessageAdded]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!message.trim()) {
            setError("Comment cannot be empty.");
            return;
        }
        try {
            setPosting(true);
            setError('');
            const formData = new FormData();
            formData.append('message', message.trim());
            const URL = activeTab === 'quote-requests' ? `chat/send-message/${activeUser?.contact?.user_handle}?chat_hash=${activeUser?.chat_hash}` : `chat/send-message/${activeUser?.contact?.user_handle}`;
            // Post Comment
            const response = await apiCall({
                url: URL,
                method: "POST",
                data: formData,
            });
            if (response.status !== 200) {
                throw new Error(`Unexpected status code: ${response.status}`);
            }
            const apiData = response.data;
            //check error after 200/ok
            if (response.status === 200 || response.status === 201) {
                if (apiData?.errors) {
                    const errors = apiData.errors;

                    Object.keys(errors).forEach((key) => {
                        const errorMessages = errors[key];
                        const firstErrorMessage = errorMessages[0]; // Take only the first error
                        setError((prevData) => ({
                            ...prevData,
                            [key]: firstErrorMessage,
                        }));
                    });
                    return; // Stop further execution if there are errors
                }
                //update last message in left bar
                const contactList = activeTab === 'quote-requests' ? quotationContact : directContact;
                updateLeftBar(contactList, activeUser, activeTab, message.trim())

                setMessage('');  // Clear
                loadOlderMessages();
                if (textareaRef.current) {
                    textareaRef.current.focus();
                }

            } else {
                setError("Failed to post comment. Please try again.");
            }
        } catch (error) {
            setError("An error occurred. Please try again.");
            handleError(error, logout, navigate);
        } finally {
            setPosting(false);
        }
    };

    const updateLeftBar = (contactList, activeUser, activeTab, message) => {
        const updatedMessage = message.trim();

        // Update the active user object
        // const updateActiveUser = {
        //     ...activeUser,
        //     last_message: updatedMessage,
        // };
        // messageDispatch({ type: "SET_ACTIVE_USER", payload: updateActiveUser });

        // Update the contact list item matching the chat_hash
        const updatedContactList = contactList.map((item) => {
            if (item?.chat_hash === activeUser?.chat_hash) {
                return {
                    ...item,
                    last_message: updatedMessage,
                };
            }
            return item;
        });

        // Dispatch or return the updated contact list if needed
        if (activeTab === 'quote-requests') {
            messageDispatch({ type: "SET_QUATATION_CONTACT_DATA", payload: updatedContactList });
            messageDispatch({
                type: "NEW_MSG_ADDED",
                payload: true
            });

        } else {
            messageDispatch({ type: "SET_DIRECT_CONTACT_DATA", payload: updatedContactList });
            messageDispatch({
                type: "NEW_MSG_ADDED",
                payload: true
            });

        }


    };

    const loadOlderMessages = async () => {


        try {
            // setLoading(true);
            const response = await apiCall({
                url: `chat/messages/${activeUser.chat_hash}?page=${1}`,
                method: "GET",
            });

            if (response.status !== 200) throw new Error(`Unexpected status: ${response.status}`);

            const apiData = response.data;

            if (apiData?.errors) {
                // messageDispatch({ type: "SET_MESSAGE_ERROR", payload: apiData.errors });
                return;
            }

            const newMessages = apiData?.chat_messages?.data || [];

            messageDispatch({
                type: "SET_MESSAGES_DATA",
                payload:
                    msg.length > 4
                        ? [...msg.slice(0, msg.length - 4), ...newMessages]
                        : newMessages,
            });
            messageDispatch({
                type: "NEW_MSG_ADDED",
                payload: true
            });


        } catch (error) {
            console.error("Older message fetch error:", error);
            messageDispatch({
                type: "SET_MESSAGE_ERROR",
                payload: "Failed to load older messages.",
            });
            handleError(error, logout, navigate);
        } finally {
            // setLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if ((e.key === 'Enter' || e.keyCode === 13) && !e.shiftKey && !e.ctrlKey) {
            e.preventDefault(); // prevent newline
            handleSubmit(e); // submit the message
        }
    };

    return (
        <div className="chat-send-message-form pt-3 pb-3">
            <Form id="chatmessageform" onSubmit={handleSubmit}>
                <div className="lead emoji-picker-container w-100 position-relative">

                    {/* <div className="d-flex justify-content-between align-items-center mb-1">
                        <div className="character-count text-muted small">
                            {maxLength - message.length} characters remaining
                        </div>
                    </div> */}

                    <div className="position-relative">
                        <TextareaAutosize
                            ref={textareaRef}
                            name="Chat[message]"
                            placeholder="Type a Message"
                            className="form-control chat-message-input pe-5 hide-scrollbar text-area-commet"
                            value={message}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            maxLength={maxLength}
                            minRows={1}
                            maxRows={10}
                            autoFocus
                            disabled={posting || activeUserStatus}
                        />
                        {/* Submit button fixed inside textarea container */}
                        <div
                            className="chat-sendbtn position-absolute d-flex justify-content-center align-items-center"
                            style={{
                                backgroundColor: (activeUser?.contact?.user_handle && message?.length > 0) ? "#000000" : '#f0f0f0'
                            }}
                            onClick={(e) => {
                                if (!posting) {
                                    handleSubmit(e);
                                }
                            }}
                            disabled={posting}
                        >
                            <PiPaperPlaneRightFill />
                        </div>

                    </div>

                    {/* Show error below the input without affecting layout */}
                    {error && (
                        <div className="text-danger small mt-1" role="alert">
                            {error}
                        </div>
                    )}
                </div>
            </Form >

        </div >
    );
};

export default MessageForm;
